export default __webpack_public_path__ + "static/media/wf-isf-economic-advantage-of-issuing-green-bonds_767x577.d7fa8d71.jpg";